<template>
  <!-- Manage Board Modal -->
  <BaseModal @close="$emit('close')">
    <template #toolbar>
      <div class="bg-white flex w-full rounded-md gap-x-3 -mb-3">
        <img
          src="../../assets/icons/new-board-icon.svg"
          alt=""
        >
        <!-- Right Side -->
        <div class="transform -translate-y-0.5">
          <div class="text-lg font-semibold">
            Add {{ selectedAds.length === 1 ? '' : selectedAds.length }} {{ selectedAds.length === 1 ? 'Ad' : 'Ads' }} to Boards
          </div>
          <div class="text-sm text-gray-500">
            Copy these ads to one or multiple boards
          </div>
        </div>
      </div>
    </template>

    <template #default>
      <div class="border-t border-border-normal pt-4">
        <div
          class="mx-5"
        >
          <div class="flex gap-x-1 mb-1">
            <BaseText
              type="label"
              size="sm"
              class="text-text-muted"
            >
              Boards
            </BaseText>
          </div>
          <BaseSingleSelect
            class="flex-1 h-full rounded-2xl w-full"
            :selected.sync="selectedBoards"
            prevent-tracking
            icon
            :items="getBoards"
            multiple
            item-value="name"
            @select="() => {}"
          >
            <template #icon>
              <svg
                width="25"
                height="25"
                viewBox="0 0 20 20"
                fill="none"
                class="-mx-2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.03502 16.6933L4.37551 16.0251H4.37551L4.03502 16.6933ZM3.30666 15.965L3.97491 15.6245H3.97491L3.30666 15.965ZM16.6933 15.965L16.0251 15.6245L16.0251 15.6245L16.6933 15.965ZM15.965 16.6933L15.6245 16.0251L15.6245 16.0251L15.965 16.6933ZM16.6933 4.03502L16.0251 4.37551L16.0251 4.37551L16.6933 4.03502ZM15.965 3.30666L15.6245 3.97491L15.6245 3.97491L15.965 3.30666ZM3.30666 4.03502L2.6384 3.69452L2.6384 3.69452L3.30666 4.03502ZM4.03502 3.30666L3.69452 2.6384L3.69452 2.6384L4.03502 3.30666ZM10.75 3.125V2.375H9.25V3.125H10.75ZM3.125 7.375H2.375V8.875H3.125V7.375ZM9.25 16.875V17.625H10.75V16.875H9.25ZM16.875 12.625H17.625V11.125H16.875V12.625ZM16.125 5.79167V14.2083H17.625V5.79167H16.125ZM14.2083 16.125H5.79167V17.625H14.2083V16.125ZM3.875 14.2083V5.79167H2.375V14.2083H3.875ZM5.79167 3.875H14.2083V2.375H5.79167V3.875ZM5.79167 16.125C5.31258 16.125 4.99837 16.1244 4.75808 16.1048C4.52654 16.0859 4.43042 16.0531 4.37551 16.0251L3.69452 17.3616C3.99613 17.5153 4.31163 17.5733 4.63593 17.5998C4.95147 17.6256 5.33733 17.625 5.79167 17.625V16.125ZM2.375 14.2083C2.375 14.6627 2.37442 15.0485 2.4002 15.3641C2.42669 15.6884 2.48472 16.0039 2.6384 16.3055L3.97491 15.6245C3.94693 15.5696 3.91413 15.4735 3.89522 15.2419C3.87558 15.0016 3.875 14.6874 3.875 14.2083H2.375ZM4.37551 16.0251C4.20303 15.9372 4.0628 15.797 3.97491 15.6245L2.6384 16.3055C2.87009 16.7602 3.2398 17.1299 3.69452 17.3616L4.37551 16.0251ZM16.125 14.2083C16.125 14.6874 16.1244 15.0016 16.1048 15.2419C16.0859 15.4735 16.0531 15.5696 16.0251 15.6245L17.3616 16.3055C17.5153 16.0039 17.5733 15.6884 17.5998 15.3641C17.6256 15.0485 17.625 14.6627 17.625 14.2083H16.125ZM14.2083 17.625C14.6627 17.625 15.0485 17.6256 15.3641 17.5998C15.6884 17.5733 16.0039 17.5153 16.3055 17.3616L15.6245 16.0251C15.5696 16.0531 15.4735 16.0859 15.2419 16.1048C15.0016 16.1244 14.6874 16.125 14.2083 16.125V17.625ZM16.0251 15.6245C15.9372 15.797 15.797 15.9372 15.6245 16.0251L16.3055 17.3616C16.7602 17.1299 17.1299 16.7602 17.3616 16.3055L16.0251 15.6245ZM17.625 5.79167C17.625 5.33733 17.6256 4.95147 17.5998 4.63593C17.5733 4.31163 17.5153 3.99613 17.3616 3.69452L16.0251 4.37551C16.0531 4.43042 16.0859 4.52654 16.1048 4.75808C16.1244 4.99837 16.125 5.31258 16.125 5.79167H17.625ZM14.2083 3.875C14.6874 3.875 15.0016 3.87558 15.2419 3.89522C15.4735 3.91413 15.5696 3.94693 15.6245 3.97491L16.3055 2.6384C16.0039 2.48472 15.6884 2.42669 15.3641 2.4002C15.0485 2.37442 14.6627 2.375 14.2083 2.375V3.875ZM17.3616 3.69452C17.1299 3.2398 16.7602 2.87009 16.3055 2.6384L15.6245 3.97491C15.797 4.0628 15.9372 4.20303 16.0251 4.37551L17.3616 3.69452ZM3.875 5.79167C3.875 5.31258 3.87558 4.99837 3.89522 4.75808C3.91413 4.52654 3.94693 4.43042 3.97491 4.37551L2.6384 3.69452C2.48472 3.99613 2.42669 4.31163 2.4002 4.63593C2.37442 4.95147 2.375 5.33733 2.375 5.79167H3.875ZM5.79167 2.375C5.33733 2.375 4.95147 2.37442 4.63593 2.4002C4.31163 2.42669 3.99613 2.48472 3.69452 2.6384L4.37551 3.97491C4.43042 3.94693 4.52654 3.91413 4.75808 3.89522C4.99837 3.87558 5.31258 3.875 5.79167 3.875V2.375ZM3.97491 4.37551C4.06279 4.20303 4.20303 4.06279 4.37551 3.97491L3.69452 2.6384C3.2398 2.87009 2.87009 3.2398 2.6384 3.69452L3.97491 4.37551ZM9.25 3.125V8.125H10.75V3.125H9.25ZM10 7.375H3.125V8.875H10V7.375ZM9.25 8.125V11.875H10.75V8.125H9.25ZM9.25 11.875V16.875H10.75V11.875H9.25ZM10 12.625H16.875V11.125H10V12.625Z"
                  fill="#5E6678"
                />
              </svg>
            </template>

            <template #item="{ item }">
              <BaseText
                type="label"
                size="xs"
                class="text-neutral-500 truncate w-4/5 overflow-hidden"
              >
                {{ item.name }}
              </BaseText>
            </template>

            <template #selection="{ item }">
              <BaseText
                type="label"
                size="xs"
                class="text-neutral-500 truncate overflow-hidden bg-neutral-25 rounded-full py-1 px-3"
              >
                {{ item.name }}
              </BaseText>
            </template>
          </BaseSingleSelect>
        </div>

        <!-- Save Board -->
        <div class="mt-5 px-5 border-t border-border-normal pt-5">
          <BaseButton
            primary
            class="ml-auto"
            :loading="loadingSave"
            :disabled="!selectedBoards.length || loadingSave"
            @click="handleAdsUpdate"
          >
            Add to {{ selectedBoards.length === 1 ? 'Board' : 'Boards' }}
          </BaseButton>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import FirebaseAPI from '@/api/firebase'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BulkAddBoardsModal',
  props: {
    selectedAds: {
      type: Array,
      default: () => []
    },
    advertisements: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selectedBoards: [],
      loadingSave: false
    }
  },
  computed: {
    ...mapGetters('BoardsModule', ['getBoards'])
  },
  methods: {
    ...mapActions('BoardsModule', ['fetchBoards', 'fetchFolders']),

    // Handle Save Board
    async handleAdsUpdate () {
      this.loadingSave = true
      try {
        const attachedBoardIds = this.selectedBoards.map((board) => board.id)
        const adsToUpdate = this.selectedAds.map((selectedAdId) => {
          const ad = this.advertisements.find(a => a.id === selectedAdId)
          const existingBoardIds = ad?.board_ids || []
          const mergedBoardIds = [...new Set([...existingBoardIds, ...attachedBoardIds])]
          return {
            id: selectedAdId,
            payload: {
              board_ids: mergedBoardIds
            }
          }
        })

        const updateResponse = await FirebaseAPI.Advertisements.updateAll(adsToUpdate)

        // Now emit the updated ads to update the ads in library view
        this.$emit('updateAds', adsToUpdate)
        this.$emit('close')

        this.$showAlert({
          message: `${updateResponse?.updatedCount} ads updated`,
          type: 'success'
        })
      } catch (error) {
        console.log(error)
        this.$showAlert({
          message: 'Error updating ads',
          type: 'error'
        })
      } finally {
        this.loadingSave = false
      }
    }
  }
}
</script>
